import DK from 'utils/dictionaries/filter_dictionary';

/* This tracks the specific keys that are used in Clear All. Since we only want
 * to clear filter params this whitelist must be kept up to date with components
 * OrderFilters and ShipmentFilters
 */
export const PANEL_FILTERS = [
  DK.ADDITIONAL_ORDER_ID,
  DK.ALL_STOP,
  DK.ANY_STOP,
  DK.ARRIVAL_AT_STOP,
  DK.AVAILABLE,
  DK.CARRIER,
  DK.CONSIGNEE_NOTIFY,
  DK.CURRENT_STATE,
  DK.CURRENT_STOP,
  DK.DATES,
  DK.DELIVERY,
  DK.DEPARTURE_FROM_STOP,
  DK.LOAD_ITEM_DESCRIPTION,
  DK.DESTINATION,
  DK.DISCHARGE,
  DK.DISPATCH,
  DK.EVENTS_AND_DATES,
  DK.FLIGHT_BOOKING,
  DK.GATE_IN_EMPTY,
  DK.GATE_IN_FULL,
  DK.GATE_OUT_EMPTY,
  DK.GATE_OUT_FULL,
  DK.ID_TYPE,
  DK.IDENTIFIER,
  DK.LOAD,
  DK.LOAD_ITEM,
  DK.LOAD_ONTO_VEHICLE,
  DK.LOCATIONS,
  DK.MANIFEST,
  DK.MODE_OF_SHIPMENT,
  DK.MODE_OF_SHIPMENT_SCOPES,
  DK.ORDER_DUE_DATE,
  DK.ORIGINAL_DELIVERY_START_DATETIME,
  DK.ORDER_IDENTIFIER,
  DK.ORDER_IDENTIFIER_CONTRACT,
  DK.ORDER_IDENTIFIER_LOAD,
  DK.ORDER_IDENTIFIER_MANUFACTURER,
  DK.ORDER_IDENTIFIER_PROMOTION,
  DK.ORDER_IDENTIFIER_SEASON,
  DK.ORDER_IDENTIFIER_VENDOR,
  DK.ORDER_STATUS,
  DK.ORDER_SUBMISSION_DATE,
  DK.ORDER_TAG_ANALYST,
  DK.ORDER_TAG_CARRIER,
  DK.ORDER_TAG_CATEGORY,
  DK.ORDER_TAG_COMMODITY,
  DK.ORDER_TAG_DEPARTMENT,
  DK.ORDER_TAG_DIRECTOR,
  DK.ORDER_TAG_FAMILY,
  DK.ORDER_TAG_GROUP,
  DK.ORDER_TAG_MANAGER,
  DK.ORDER_TAG_SECTOR,
  DK.ORDER_TYPE,
  DK.ORIGIN,
  DK.OUT_FOR_DELIVERY,
  DK.PICKED_UP,
  DK.PROPERTIES,
  DK.RECEIVE_FROM_SHIPPER,
  DK.REFERENCE_KEY,
  DK.RELATED_ENTITY_ID,
  DK.RETURN_TO_SENDER,
  DK.SUPPLIER_READY_DATE,
  DK.SUPPLIER_READY_START_DATETIME,
  DK.SKU,
  DK.TAGS,
  DK.UNLOAD_FROM_VEHICLE,
  DK.UPC,
  DK.VESSEL_OR_VEHICLE_ID,
  DK.RELATED_ENTITY_ID,
  DK.ORDER_REFERENCE_KEY,
  DK.ORDER_PROPERTIES,
  DK.ORDER_IDENTIFIER,
  DK.ORDER_DATE,
  DK.ORDER_TAGS,
  DK.CURRENT_STOP,
  DK.CONNECTIVITY,
  DK.TRACKING_START,
  DK.TRACKING_FAILED,
  DK.UNKNOWN_EQUIPMENT_IDENTIFIER,
  DK.MISSING_EQUIPMENT_IDENTIFIER,
  DK.TRACKING_END_BY_USER,
  DK.TRACKING_END_DUE_TO_TIMEOUT,
  DK.DRIVER_DENY_TRACKING,
];

export const SORT_FILTERS = [DK.SORT_BY];

export const SEARCH_FILTERS = [DK.SEARCH_TEXT];

export const ALL_FILTERS = [
  ...PANEL_FILTERS,
  ...SORT_FILTERS,
  ...SEARCH_FILTERS,
];
